import React from 'react';
import { SegmentedControl } from './SegmentedControl';
import type { PermLevel, PermissionArea } from '../data/catalog';

interface PermissionAreaCardProps {
  area: PermissionArea;
  value: PermLevel;
  onChange: (level: PermLevel) => void;
}

/** A single permission area: title + description with its access-level control. */
export const PermissionAreaCard: React.FC<PermissionAreaCardProps> = ({ area, value, onChange }) => (
  <div className="rounded-xl border border-gray-200 p-5 dark:border-gray-700">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h3 className="text-base font-medium text-gray-900 dark:text-gray-100">{area.title}</h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{area.description}</p>
      </div>
      <SegmentedControl value={value} levels={area.levels} onChange={onChange} />
    </div>
  </div>
);

export default PermissionAreaCard;
